module.exports = __webpack_public_path__ + "img/待检查.e870de04.png";